// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
}
import Vue from 'vue'
import App from './App'
import VueAnalytics from 'vue-ua'
import router from './router'
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue'
import VueHtmlToPaper from 'vue-html-to-paper';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/fontawesome-all.css'
import '@/assets/css/style.css'
import '@/assets/css/Site.css'

import VueResource from 'vue-resource';
import store from './store';
import VueQRCodeComponent from 'vue-qrcode-component'
import VuejsDialog from 'vuejs-dialog';
//import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.use(VueAnalytics, {
  appName: 'msobcfdc.in', // Mandatory
  appVersion: '1.0.0', // Mandatory
  trackingId: 'UA-178771855-1', // Mandatory
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  createOptions: { // Optional, Option when creating GA tracker, ref: https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference
    siteSpeedSampleRate: 10,
  },
})



//import Print from "vue-print-nb";
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];
Vue.filter('formatDate', function (value) {
  if (!value) return '';
  if (value == '0001-01-01T00:00:00') return '';
  let dbDateTime = new Date(value);

  let formattedDate =
    dbDateTime.getDate() +
    "-" +
    months[dbDateTime.getMonth()] +
    "-" +
    dbDateTime.getFullYear();
  return formattedDate;
});

Vue.use(VueHtmlToPaper, options);
Vue.component('qr-code', VueQRCodeComponent)
Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(Vuex);
//Vue.use(Print);
Vue.use(VuejsDialog);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js